import { generatePath } from 'react-router-dom';
import type { Campaign } from 'c-sdk';
import { PostAuthRoutes } from 'c-routes';

export type CampaignTabAccess = {
    reporting: boolean;
    displays: boolean;
    creatives: boolean;
    costs: boolean;
};

/**
 * The tab a campaign opens on: reporting when it has PCA data, otherwise the first tab the user
 * may open. `null` when they may open none, so the caller can say so instead of waiting forever.
 */
export const campaignLandingRoute = (
    campaign: Pick<Campaign, 'id' | 'pca_available'>,
    access: CampaignTabAccess,
    email?: string | null,
): string | null => {
    const id = campaign.id;
    if (email === 'natasha.marcou@uniledsoftware.com') {
        return generatePath(PostAuthRoutes.Campaigns.CampaignDisplays, { id });
    }
    if (access.reporting && Object.values(campaign.pca_available ?? {}).length > 0) {
        return generatePath(PostAuthRoutes.Campaigns.CampaignReporting, { id });
    }
    if (access.displays) {
        return generatePath(PostAuthRoutes.Campaigns.CampaignDisplays, { id });
    }
    if (access.creatives) {
        return generatePath(PostAuthRoutes.Campaigns.CampaignCreatives, { id });
    }
    if (access.reporting) {
        return generatePath(PostAuthRoutes.Campaigns.CampaignReporting, { id });
    }
    if (access.costs) {
        return generatePath(PostAuthRoutes.Campaigns.CampaignCostsPage, { id });
    }
    return null;
};
